import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';
import { useTheme } from '@material-ui/core/styles';

const MercosurPodcastHero = ({ hero = {}, themeMode = 'light' }) => {
  const theme = useTheme();
  const tnoLogoSrc =
    hero.tnoLogo || (themeMode === 'dark' ? '/images/logos/logo_white.PNG' : '/images/logos/logo_tnonetwork_black.png');
  const showTnoLogo = hero.showTnoLogo === true || (hero.showTnoLogo !== false && !hero.image);

  return (
    <Box textAlign="center" py={{ xs: 3, md: 5 }}>
      {showTnoLogo && (
        <Box
          component="img"
          src={tnoLogoSrc}
          alt="TNO Network"
          sx={{
            maxWidth: 280,
            width: '100%',
            height: 'auto',
            mb: 3,
            mx: 'auto',
            display: 'block',
          }}
        />
      )}
      {hero.overline && (
        <Chip
          label={hero.overline}
          color="primary"
          size="small"
          sx={{ mb: 2, fontWeight: 600, letterSpacing: 0.5 }}
        />
      )}
      {hero.image && (
        <Box
          component="img"
          src={hero.image}
          alt={hero.imageAlt || 'Mercosur Casa de Bolsa'}
          sx={{
            maxWidth: 220,
            width: '100%',
            height: 'auto',
            mb: 3,
            mx: 'auto',
            display: 'block',
          }}
        />
      )}
      <Typography variant="h3" sx={{ fontWeight: 800, color: theme.palette.primary.main }} gutterBottom>
        {hero.title}
      </Typography>
      <Typography variant="h6" color="textSecondary" sx={{ maxWidth: 720, mx: 'auto', mb: 3 }}>
        {hero.subtitle}
      </Typography>
      {hero.analysisText && (
        <Typography variant="body1" color="textSecondary" sx={{ maxWidth: 800, mx: 'auto', lineHeight: 1.7 }}>
          {hero.analysisText}
        </Typography>
      )}
    </Box>
  );
};

MercosurPodcastHero.propTypes = {
  hero: PropTypes.object,
  themeMode: PropTypes.string,
};

export default MercosurPodcastHero;
